import { Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './component/ScrollToTop';
import Home from './component/Home';
import SoftwareForm from './component/courseForm/SoftwareForm';
import TailoringDetail from './component/courseDetails/TailoringDetail';
import SoftwareDetail from './component/courseDetails/SoftwareDetail';
import AariDetail from './component/courseDetails/AariDetails';
import Aboutus from './component/Aboutus';
import ServicePage from './component/ServicePage';
import Contactus from './component/Contactus';
// import WorkInProgress from './component/workInProgress/WorkInProgress';
import TailoringForm from './component/courseForm/TailoringForm';
import AariForm from './component/courseForm/AariForm';
import MainLayout from './component/Layouts/MainLayout';
import FormLayout from './component/Layouts/FormLayout';

function App() {
  return (
    <div className="App">
      <ScrollToTop/>
      <Routes>
        {/* Routes with Navbar + Footer */}
        <Route element={<MainLayout />}>
          <Route path='/' element={<Home />} />
          <Route path='/aboutus' element={<Aboutus />} />
          <Route path='/services' element={<ServicePage />} />
          <Route path='/contactus' element={<Contactus />} />
          <Route path='/tailoringDetail' element={<TailoringDetail />} />
          <Route path='/softwareDetail' element={<SoftwareDetail />} />
          <Route path='/aariDetail' element={<AariDetail />} />
        </Route>

        {/* Routes without Navbar + Footer */}
        <Route element={<FormLayout />}>
          <Route path='/courses/sdc-register' element={<SoftwareForm />} />
          {/* <Route path="/workinprogress" element={<WorkInProgress />} /> */}
          <Route path="/tailoring-form" element={<TailoringForm />} />
          <Route path="/aari-form" element={<AariForm />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;